import React from 'react';
import {Spinner} from '@blueprintjs/core';

import './Loading.scss';

interface LoadingProps {
  size?: number;
  className?: string;
}

export const Loading = ({size = 18, className = ''}: LoadingProps) =>
  <Spinner size={size} className={'loading-spinner ' + className}/>;
